import { PLAY_STORE_URL } from '@danda/shared';

interface PlayStoreBadgeProps {
  className?: string;
}

/** Official "Get it on Google Play" badge linking to the live Polymyth listing. */
export default function PlayStoreBadge({ className = '' }: PlayStoreBadgeProps) {
  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get Polymyth on Google Play"
      className={`inline-block transition-opacity hover:opacity-80 ${className}`}
    >
      <img src="/get-it-on-google-play.png" alt="Get it on Google Play" className="h-12 w-auto" />
    </a>
  );
}
